<template>
  <draggable v-model="block.blockItems" item-key="id" :handle="'.drag'" class="components" :data-block-uniqueId="block.uniqueId"
             :group="componentsGroup" :force-fallback="true" ghost-class="ghost" chosen-class="chosen" @start="onStart" @end="onEnd">
    <transition-group type="transition" :name="!dnd.dragInProgress.value && !dnd.dragComponent.value ? 'fade' : null" @before-leave="dnd.beforeLeave">
      <TapComponent v-for="component in renderedComponents" :key="component.id" :component="component" :block="block" />
    </transition-group>
  </draggable>
</template>


<script setup lang="ts">
import { VueDraggableNext as draggable } from 'vue-draggable-next'
import TapComponent from './TapComponent.vue'
import { useDnd } from '@/composables/useDnd'
import { useComponents } from '@/composables/useComponents'
import { computed } from 'vue'
import {useTapStore} from '@/stores/tapStore'
import {publicComponentVisible} from '@/components/types/tariffs/publicModel'

const props = defineProps<{ block: any }>()
const tapStore = useTapStore()
const renderedComponents = computed(() => tapStore.view
  ? props.block.blockItems.filter(publicComponentVisible)
  : props.block.blockItems)
const dnd = useDnd()
const componentsGroup = computed(() => ({ name: 'components', pull: true, put: (to, from, item) => item.dataset.type === 'component' }))
const { cleanupEmptyBlocks, saveMoveComponent } = useComponents()


const onStart = () => { dnd.dragComponent.value = true; dnd.dragInProgress.value = true }
const onEnd = (event: any) => {
  saveMoveComponent(event.to.dataset.blockUniqueid, event.item._underlying_vm_.uniqueId, event.newIndex)
  setTimeout(() => {
    dnd.dragComponent.value = false
    dnd.dragInProgress.value = false
  }, 1)

  cleanupEmptyBlocks(true)
}
</script>

<style scoped lang="sass">
.components
  display: flex
  flex-direction: column

.chosen
  opacity: 1 !important

.ghost
  opacity: 0 !important

.fade-move
  transition: transform 0.25s ease

.fade-leave-active
  transition: opacity 0.2s ease, height 0.25s ease, padding 0.25s ease, margin 0.25s ease

.fade-leave-from
  opacity: 1
  height: var(--real-height)
  margin-bottom: 12px
  padding: 8px!important
  margin-top: 0
  &:last-child
    margin-bottom: 0

.fade-leave-to
  opacity: 0
  height: 0
  margin-bottom: 0
  padding: 0!important
  &:last-child
    &:not(:first-child)
      margin-top: -12px

.fade-enter-active
  transition: opacity 0.2s ease, height 0.25s ease, padding 0.25s ease, margin 0.25s ease

.fade-enter-from
  background: blue
  opacity: 0
  height: 0
  margin-bottom: 0
  padding: 0!important
  margin-top: 0

.fade-enter-to
  opacity: 1
  height: var(--real-height)
  margin-bottom: 12px
  padding: 8px!important
  &:last-child
    margin-bottom: 0
    &:not(:first-child):not(.moved-up)
      margin-top: -12px
</style>
